// extracted by mini-css-extract-plugin
export default {"button":"activityLink_button__R6vIh","spanWrap":"activityLink_spanWrap__VdK87"};